module.exports = __webpack_public_path__ + "static/media/css.f12256ac.svg";